var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ValidationProvider", {
    ref: "selectValidator",
    attrs: {
      name: _vm.$attrs.id,
      rules: _vm.validationRules,
      tag: "div",
      vid: _vm.$attrs.id,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasRelatedData,
                    expression: "hasRelatedData",
                  },
                ],
                class: [
                  { "form-layer-is-open": _vm.formLayerIsOpen },
                  { "error-styles": errors[0] },
                  "lf-select-container",
                  { "disabled-field": _vm.disabled },
                  {
                    "show-all-chips":
                      _vm.isMultiselect && _vm.renderChips && _vm.showAllChips,
                  },
                  {
                    "show-chips":
                      _vm.isMultiselect && _vm.renderChips && !_vm.showAllChips,
                  },
                ],
              },
              [
                _c(
                  "span",
                  {
                    class: [
                      { "required-field": _vm.requiredField },
                      "label-text",
                    ],
                  },
                  [_vm._v(_vm._s(_vm.$attrs.label))]
                ),
                _c(
                  "v-select",
                  _vm._g(
                    {
                      key: _vm.componentKey,
                      ref: "vSelect",
                      class: [
                        "lf-select",
                        "lf-multiselect-list",
                        {
                          "is-mobile": _vm.isMobile,
                          "error-styles": errors[0],
                          "is-source-table": _vm.sourceIsATable,
                        },
                      ],
                      attrs: {
                        value: _vm.getSelectedItems,
                        items: _vm.filteredList,
                        "item-disabled": _vm.isItemDisabled,
                        height: "38",
                        multiple: _vm.isMultiselect ? true : false,
                        chips: _vm.renderChips ? true : false,
                        "item-text": _vm.keyName,
                        "item-value": _vm.keyValue,
                        "append-icon": _vm.icons.arrowDown,
                        "clear-icon": _vm.icons.clearIcon,
                        id: _vm.$attrs.id,
                        name: _vm.$attrs.name,
                        placeholder: _vm.$attrs.placeholder,
                        "hide-details": "",
                        "return-object": _vm.returnObject,
                        disabled: _vm.disabled,
                        dense: "",
                        attach: _vm.attach,
                        clearable: _vm.clearable,
                        "menu-props": {
                          offsetY: true,
                          maxWidth: _vm.selectWidth,
                        },
                      },
                      on: {
                        "click:clear": _vm.clearSearch,
                        input: _vm.setSelectedItems,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "no-data",
                            fn: function () {
                              return [_c("span")]
                            },
                            proxy: true,
                          },
                          _vm.renderChips
                            ? {
                                key: "selection",
                                fn: function ({ item, index }) {
                                  return [
                                    index <= 2 || _vm.showAllChips
                                      ? _c(
                                          "v-chip",
                                          {
                                            staticClass: "chip",
                                            attrs: { close: "" },
                                            on: {
                                              "click:close": function ($event) {
                                                return _vm.removeChipItem(
                                                  item[_vm.keyId],
                                                  item[_vm.keyName]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(item[_vm.keyName])),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    index === 3 && !_vm.showAllChips
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "more-items-selected-number",
                                          },
                                          [
                                            _vm._v(
                                              "+" +
                                                _vm._s(_vm.value.length - 3) +
                                                " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "components.autocomplete.other"
                                                  )
                                                )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              }
                            : null,
                          _vm.showSearch
                            ? {
                                key: "prepend-item",
                                fn: function () {
                                  return [
                                    _c("div", { staticClass: "sticky" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "search-field-and-buttons-container",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "search-field-container",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.search,
                                                    expression: "search",
                                                  },
                                                ],
                                                staticClass: "search-field",
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "action_buttons.search"
                                                  ),
                                                },
                                                domProps: { value: _vm.search },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.search =
                                                      $event.target.value
                                                  },
                                                },
                                              }),
                                              _vm.search.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "clear-icon-container",
                                                      on: {
                                                        click: _vm.clearSearch,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        class: [
                                                          "clear-icon",
                                                          _vm.icons.clearIcon,
                                                        ],
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "search-icon-container",
                                                  on: {
                                                    click: _vm.clearSearch,
                                                  },
                                                },
                                                [
                                                  _c("span", {
                                                    class: [
                                                      "search-icon",
                                                      _vm.icons.searchIcon,
                                                    ],
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm.canSave
                                            ? _c("button", {
                                                class: [
                                                  "add-new-button",
                                                  _vm.icons.addNew,
                                                  "lf-icon__md",
                                                ],
                                                attrs: {
                                                  title: _vm.$t(
                                                    "components.tooltip.add_new"
                                                  ),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.openForm.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm.sourceIsATable &&
                                      !_vm.isMobile &&
                                      _vm.hasItems
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "table-headers-container",
                                            },
                                            _vm._l(
                                              _vm.tableHeadersWithAlias,
                                              function (header) {
                                                return _c(
                                                  "span",
                                                  {
                                                    staticClass: "table-header",
                                                    style: `width: ${header.width}%;`,
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          `components.lexon_select.table_headers.${
                                                            header.title ||
                                                            header.name
                                                          }`
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                      _vm.showNoResultsText
                                        ? _c(
                                            "p",
                                            {
                                              staticClass: "no-results-message",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "components.no_results.no_search_results_text"
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                          _vm.sourceIsATable && !_vm.loading
                            ? {
                                key: "item",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "table-item-container" },
                                      _vm._l(
                                        _vm.getTableHeaders,
                                        function (header, itemIndex) {
                                          return _c(
                                            "span",
                                            {
                                              key: itemIndex,
                                              staticClass: "table-item",
                                              style: `width: ${header.width}%;`,
                                              attrs: {
                                                "data-title": item[header.name],
                                              },
                                            },
                                            [_vm._v(_vm._s(item[header.name]))]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                },
                              }
                            : _vm.loading
                            ? {
                                key: "item",
                                fn: function ({ item }) {
                                  return [_c("span")]
                                },
                              }
                            : _vm.isColorSelector
                            ? {
                                key: "item",
                                fn: function ({ item }) {
                                  return [
                                    _c("div", { staticClass: "color-item" }, [
                                      _c("div", {
                                        staticClass: "color-square",
                                        style: `backgroundColor: ${item.color};`,
                                      }),
                                      _c("span", [
                                        _vm._v(_vm._s(item[_vm.keyName])),
                                      ]),
                                    ]),
                                  ]
                                },
                              }
                            : null,
                          _vm.showPaginator
                            ? {
                                key: "append-item",
                                fn: function () {
                                  return [
                                    _vm.loading
                                      ? _c("SpinnerLayerComponent", {
                                          staticClass: "spinner-layer",
                                          attrs: {
                                            loadingText: _vm.$t(
                                              "components.grid_table.updating"
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                    _c("PaginationComponent", {
                                      staticClass: "pagination-component",
                                      style: _vm.cssVars,
                                      attrs: {
                                        totalPages: _vm.numberOfPages,
                                        currentPage: _vm.currentPage,
                                        maxVisibleButtons:
                                          _vm.paginatorMaxVisibleButtons,
                                      },
                                      on: { pageChanged: _vm.changedPage },
                                    }),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    },
                    _vm.$listeners
                  )
                ),
                _c("div", { staticClass: "messages-container" }, [
                  errors.length
                    ? _c("span", { staticClass: "alert-message" }, [
                        _vm._v(_vm._s(errors[0])),
                      ])
                    : _c("span", { staticClass: "help-message" }, [
                        _vm._v(_vm._s(_vm.helpText)),
                      ]),
                ]),
              ],
              1
            ),
            _vm.showAddNewButton
              ? _c("LexonSelectFormComponent", {
                  attrs: {
                    title: _vm.parseFormTitle,
                    isOpened: _vm.formLayerIsOpen,
                    field: _vm.$attrs,
                    formAlias: _vm.formAlias,
                    saveEndPoint: _vm.saveMethod,
                    relatedData: _vm.relatedData,
                    filterField: _vm.filterField,
                    filteredValue: _vm.filteredValue,
                    showRequiredFieldsAdvice: _vm.showRequiredFieldsAdvice,
                    parentField: _vm.parentField,
                  },
                  on: { close: _vm.closeForm, save: _vm.saveForm },
                })
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }